import { cx, css } from '@linaria/core';
import { Slider } from 'components/Slider';
import { observer } from 'mobx-react-lite';
import { flex } from 'styles/utils/core';
import React, { useCallback } from 'react';
import { withGuaranteedPredStore } from 'modules/Predictions/withGuaranteedPredStore';
import { Input } from 'components/Input';
import { isNaN } from 'lodash';
import { baseTheme } from 'styles/utils';
interface ThresholdSliderProps {
  minThreshold: number;
  setMinThreshold: (num: number) => void;
}
export const ThresholdSlider = withGuaranteedPredStore(observer(({
  minThreshold,
  setMinThreshold
}: ThresholdSliderProps): JSX.Element => {
  const changeHandler = useCallback((num: number) => setMinThreshold(num), [setMinThreshold]);
  const inputChangeHandler = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    let value = Number.parseFloat(e.target.value);
    if (isNaN(value)) {
      value = 0;
    }
    if (value < 0) {
      value = 0;
    } else if (value >= 1) {
      value = 1;
    }
    setMinThreshold(value);
  }, [setMinThreshold]);
  return <div className={sliderStyles}>
        <h4 className="slider-title">Prediction Threshold</h4>
        <div className="slider-description">The slider with adjust the results shown within the specified range.</div>
        <div className={cx('sliderInput', flex.init, flex.alignItems.center, flex.justifyContent.center)}>
          <Slider data-testid="threshold-slider" name="threshold" className="slider" min={0} max={1} step={0.02} value={minThreshold} onChange={changeHandler} primaryColor={baseTheme.light.colors.gray200} secondaryColor={baseTheme.light.colors.primary600} />
          <Input className="input_value" value={minThreshold.toString()} type="number" min={0} max={1} step={0.02} onChange={inputChangeHandler} />
        </div>
      </div>;
}));
const sliderStyles = "omponents__ModelOutputRenderer__components__CollapsibleBar__components__ThresholdSlider_tsx-sliderStyles-sibrmv4";

require("./ThresholdSlider.linaria.module.css!=!../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ThresholdSlider.tsx");